import React from 'react'
import PatentPDFGenerator from '../PatentPDFGenerator';
import '../components/PatentForm.css';
import { useLocation } from 'react-router-dom';


function Patentpreview() {
    const location = useLocation();
    const { data } = location.state || {};
    return (
        <div>
            {data &&
                <PatentPDFGenerator
                    every={data}
                   
                />}
           
        </div>
    )
}

export default Patentpreview